/*
 * Descripción del producto en franjas: índice fijo bajo la cabecera y apartado activo.
 * Markup: snippets/product-franjas.liquid
 */
(function () {
  "use strict";

  function iniciar() {
    var raiz = document.querySelector("[data-franjas]");
    if (!raiz) return;
    var indice = raiz.querySelector("[data-franjas-indice]");
    var cabecera = document.querySelector(".shopify-section-main-header");

    // El índice se pega justo debajo de la cabecera cuando esta está visible.
    var pendiente = false;
    function ajustarTop() {
      pendiente = false;
      var top = 0;
      if (cabecera) {
        var header = cabecera.querySelector("header");
        var oculta = header && header.classList.contains("sticky-header-hidden");
        var abajo = cabecera.getBoundingClientRect().bottom;
        if (!oculta && abajo > 0) top = Math.round(abajo);
      }
      raiz.style.setProperty("--franjas-indice-top", top + "px");
    }
    function alHacerScroll() {
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(ajustarTop);
      }
    }
    ajustarTop();
    window.addEventListener("scroll", alHacerScroll, { passive: true });
    window.addEventListener("resize", alHacerScroll);

    if (!indice || !("IntersectionObserver" in window)) return;

    var enlaces = Array.prototype.slice.call(indice.querySelectorAll("a[href^='#']"));
    var porId = {};
    enlaces.forEach(function (a) { porId[a.getAttribute("href").slice(1)] = a; });

    function activar(enlace) {
      enlaces.forEach(function (a) { a.classList.toggle("is-activa", a === enlace); });
      if (!enlace) return;
      var lista = enlace.closest("ul");
      if (lista && lista.scrollWidth > lista.clientWidth) {
        var izquierda = enlace.offsetLeft - (lista.clientWidth - enlace.offsetWidth) / 2;
        lista.scrollTo({ left: Math.max(0, izquierda), behavior: "smooth" });
      }
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting && porId[e.target.id]) activar(porId[e.target.id]);
      });
    }, { rootMargin: "-40% 0px -55% 0px" });

    Array.prototype.forEach.call(raiz.querySelectorAll("[data-franja]"), function (s) {
      if (s.id) observador.observe(s);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
